import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { miscSessionFetch } from '../../../../api-client/api-svcpp-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const getMiscSessionFetch = createAsyncThunk(
    'getMiscSessionFetch/Get',
    async (body, { rejectWithValue }) => {
        try {
            const response = await miscSessionFetch(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'GET_MISC_SESSION_FETCH_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const getMiscSessionFetchSlice = createSlice({
    name: 'getMiscSessionFetch',
    initialState,
    extraReducers: {
        [getMiscSessionFetch.pending]: (state) => {
            state.loading = true;
        },
        [getMiscSessionFetch.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [getMiscSessionFetch.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const getMiscSessionFetchSelector = (state) => state.getMiscSessionFetch;
export const getMiscSessionFetchReducer = getMiscSessionFetchSlice.reducer;
